import { useState } from "react"
import { useTheme } from "@material-ui/core/styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons"
import { faUsers, faGlobe } from "@fortawesome/free-solid-svg-icons"
import {
  faInstagram,
  faFacebookSquare,
} from "@fortawesome/free-brands-svg-icons"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { VenueMiniMap } from "./VenueMiniMap"

export default function VenueRightCard({ venue, onStartReservation }) {
  const theme = useTheme()
  const [showPhone, setShowPhone] = useState(false)

  let guestsRange
  const hasMinGuests = Number.isInteger(venue.minGuests)
  const hasMaxGuests = Number.isInteger(venue.maxGuests)
  if (hasMinGuests && hasMaxGuests) {
    guestsRange = `${venue.minGuests}-${venue.maxGuests}`
  } else if (hasMinGuests) {
    guestsRange = `${venue.minGuests}+`
  } else if (hasMaxGuests) {
    guestsRange = `0-${venue.maxGuests}`
  } else {
    guestsRange = "0+"
  }

  return (
    <article className="bg-white rounded-xl border">
      <section className="border-b p-4 flex items-center justify-between">
        <Typography variant="h5" component="h2">
          {venue.name}
        </Typography>
        <div className="flex">
          {venue.websiteUrl && (
            <a href={venue.websiteUrl} target="_blank" className="px-2 text-xl">
              <FontAwesomeIcon icon={faGlobe} />
            </a>
          )}
          {venue.instagramUrl && (
            <a
              href={venue.instagramUrl}
              target="_blank"
              className="px-2 text-xl"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          )}
          {venue.facebookUrl && (
            <a
              href={venue.facebookUrl}
              target="_blank"
              className="px-2 text-xl"
            >
              <FontAwesomeIcon icon={faFacebookSquare} />
            </a>
          )}
        </div>
      </section>
      <section className="p-4 text-sm md:text-base">
        <button
          className="py-2 w-full flex items-center underline focus:outline-none"
          style={{
            color: theme.palette.primary.main,
          }}
          type="button"
          onClick={() => setShowPhone((state) => !state)}
          aria-pressed={showPhone}
        >
          <span className="text-lg">
            <FontAwesomeIcon icon={showPhone ? faEyeSlash : faEye} />
          </span>
          <span className="ml-2">
            {showPhone ? venue.phone : "Pokaż numer telefonu"}
          </span>
        </button>
        <div className="py-2 w-full flex items-center">
          <span className="text-lg">
            <FontAwesomeIcon icon={faUsers} />
          </span>
          <span className="ml-2">{guestsRange}</span>
        </div>
        <div>
          {venue.lat && venue.lng && (
            <div
              className="h-48 rounded-xl my-2"
              style={{ border: "1px solid #E7E7E7" }}
            >
              <VenueMiniMap venue={venue} />
            </div>
          )}
        </div>
        <div className="py-2 w-full flex items-center">
          {venue.address}
          {venue.city ? `, ${venue.city}` : ""}
        </div>
        {venue.lat && venue.lng && (
          <div
            className="my-2"
            style={{
              color: "var(--moje-color-magenta)",
              textDecoration: "underline",
            }}
          >
            <a
              href={`https://maps.google.com/maps/search/?api=1&query=${venue.lat},${venue.lng}`}
              target="_blank"
            >
              Dojazd
            </a>
          </div>
        )}
      </section>
      <section className="border-t p-4 flex flex-wrap justify-around items-center">
        <Button
          className="text-sm m-1 w-full xl:w-auto"
          variant="contained"
          color="primary"
          onClick={() => {
            console.log("Sprawdz", onStartReservation)
            onStartReservation()
          }}
        >
          Sprawdź terminy
        </Button>
        {/* <Button
          className="text-sm m-1 w-full xl:w-auto"
          variant="contained"
          color="primary"
          onClick={() => {
            var element_to_scroll_to = document.getElementById("question")
            element_to_scroll_to.scrollIntoView({
              behavior: "smooth",
              block: "start",
            })
          }}
        >
          Wyślij zapytanie
        </Button> */}
      </section>
    </article>
  )
}
